import useFooter from "../../../logic/Footer";
import InnerHTML from "dangerously-set-html-content";

const Footer = () => {
  const { footer, script } = useFooter();

  return (
    <footer className="hnf-footer" role="contentinfo">
      <InnerHTML html={footer && footer} />
      <InnerHTML html={footer && script} />
    </footer>
  );
};

export default Footer;
